import { sortBy } from 'lodash-es';
import { Settings } from 'luxon';
import { getTimeZones, setTimezone } from '../api';
import {
  convertTranslationsToLowerCase,
  getInitialTranslations,
  getTranslations
} from '../utils';
import { setLang } from '../utils/setLang';
import {
  getStoredTranslations,
  setStoredTranslations
} from '../utils/storedLanguageTranslation';
import { useI18nStore } from './store';

export const actionsCreator = ({ getState, setState }) => ({
  SET_INITIAL_LANG_TRANSLATIONS: async ({
    lang,
    cookieManagementEnabled,
    isLoadFallbackTranslations = false
  }) => {
    try {
      Settings.defaultLocale = lang;
      setLang(lang, cookieManagementEnabled);

      if (getState().isTranslationsInitialized) {
        return;
      }

      const storedTranslations = getStoredTranslations(lang);
      if (storedTranslations) {
        setState({
          language: lang,
          translations: storedTranslations,
          isTranslationsInitialized: true
        });
      }

      const translations = await getInitialTranslations(
        lang,
        isLoadFallbackTranslations
      );

      const normalizedTranslations =
        convertTranslationsToLowerCase(translations);

      setState({
        language: lang,
        translations: normalizedTranslations,
        isTranslationsInitialized: true
      });

      setStoredTranslations(lang, normalizedTranslations);
    } catch (error) {
      console.error('Initial translation load failed', error);
    }
  },

  SET_LANG_TRANSLATIONS: async ({
    lang,
    cookieManagementEnabled,
    isLoadFallbackTranslations = true
  }) => {
    try {
      Settings.defaultLocale = lang;
      setLang(lang, cookieManagementEnabled);
      const translations = await getTranslations(
        lang,
        isLoadFallbackTranslations
      );

      if (translations != null) {
        const normalizedTranslations =
          convertTranslationsToLowerCase(translations);

        setState({
          language: lang,
          translations: normalizedTranslations
        });

        setStoredTranslations(lang, normalizedTranslations);
      } else {
        setState({ language: lang });
      }
    } catch (error) {
      console.error('Translation load failed', error);
    }
  },

  CHANGE_TIMEZONE: async (timezone) => {
    try {
      await setTimezone(timezone);
      setState({ timezone });
    } catch (e) {
      console.warn(e);
    }
  },

  FETCH_TIMEZONES: async () => {
    const timeZones = await getTimeZones();
    setState({
      timeZones: sortBy(timeZones, 'timezoneDiff')
    });
  }
});

export const i18nActions = actionsCreator(useI18nStore);
